<template>
  <div
    class="furnitureIcon"
    :style="{ width: `${props.width}px`, height: `${props.height}px` }"
    tabindex="0"
    :draggable="props.draggable"
  >
    <img v-if="iconUrl" :src="iconUrl" alt="" class="img" :draggable="false" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { FurnitureIconType } from '@/types/furniture'
import { furnitureIconUrlMap, resolveFurnitureIconType } from '@/const/furniture'

defineOptions({
  name: 'FurnitureIcon',
})

type Props = {
  icon: FurnitureIconType | string
  width?: number
  height?: number
  draggable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  icon: 'bed',
  width: 50,
  height: 50,
  draggable: true,
})

const iconUrl = computed(() => {
  const resolved = resolveFurnitureIconType(props.icon)
  return resolved ? furnitureIconUrlMap[resolved] : undefined
})
</script>

<style scoped lang="less">
.furnitureIcon {
  flex-shrink: 0;
  user-select: none;
  pointer-events: none;
  .img {
    width: 100%;
    height: 100%;
    vertical-align: top !important;
  }
}
</style>
